
import * as Moment from 'moment';

// eslint-disable-next-line import/prefer-default-export
export const transformSteps = steps => steps.map((step) => {
  const stepMapped = step;
  stepMapped.pitches = step.pitches.map((pitch) => {
    const pitchMapped = pitch;
    pitchMapped.collapsed = true;
    return pitchMapped;
  });
  return step;
});

export const stripHTMLTags = body => body.replace(/<(.|\n)*?>/g, ' ');

export const orderSteps = steps => steps.sort((a, b) => (
  Moment.duration(a.send_from_launch_duration).asSeconds()
  - Moment.duration(b.send_from_launch_duration).asSeconds()
));

export const unescapeHtml = (html) => {
  const temp = document.createElement('textarea');
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || '';
};

export const filterLegacyTemplateFields = fields => fields.filter(field => field.name.indexOf(' ') === -1);
